import type { EvidenceFileRow } from 'components/EvidenceFiles/EvidenceFiles';
export const pickedEvidenceFiles = (files: File[]): EvidenceFileRow[] =>
  files.map((file) => ({ key: file.name, filename: file.name, size: file.size }));
